module.exports = __webpack_public_path__ + "static/media/tapari_tee_dirgha.c0eb253f.ogg";